import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateErrorComponentService } from '@abp/ng.theme.shared';
import { CustomHttpErrorHandlerService } from '@abp/ng.theme.shared';

@Injectable({ providedIn: 'root' })
export class BackendUnavailableErrorHandlerService implements CustomHttpErrorHandlerService {
  // Higher priority than ABP's UnknownStatusCodeErrorHandlerService (normal = 0)
  readonly priority = 9;

  private readonly createErrorComponentService = inject(CreateErrorComponentService);

  canHandle(error: unknown): boolean {
    return error instanceof HttpErrorResponse && error.status === 0;
  }

  execute(): void {
    this.createErrorComponentService.execute({
      status: 0,
      hideCloseIcon: true,
      isHomeShow: false,
    });
  }
}
